import React, { useState, useEffect } from 'react';
import { LinearProgress } from '@mui/material';
import { useApolloNetworkStatus } from '@ts-private/apollo-tools/links/networkStatus';
import { networkStatusLinkConfig as config } from 'apollo/config';

const GlobalLoadingIndicator = () => {
  const [pending, setPending] = useState(false);
  const status = useApolloNetworkStatus(config);

  useEffect(() => {
    setPending(status.pendingQueryCount > 0 || status.pendingMutationCount > 0);
  }, [status]);

  return pending ? <LinearProgress /> : <></>;
};

export default GlobalLoadingIndicator;
